import { render, staticRenderFns } from "./TabelaMostraListaTitulo.vue?vue&type=template&id=28f2fe71&"
import script from "./TabelaMostraListaTitulo.vue?vue&type=script&lang=js&"
export * from "./TabelaMostraListaTitulo.vue?vue&type=script&lang=js&"
import style0 from "./TabelaMostraListaTitulo.vue?vue&type=style&index=0&id=28f2fe71&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports